var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{staticClass:"mt-5",attrs:{"title":"Applicant"}}),_c('div',[_c('AllApplications')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }